import React from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { indexSeoSelector } from '~/Index/selectors';
import Serp from '../app/Serp';
import { setSearchParams } from '../app/Serp/actions';
import { fetchIndexSeoRequest } from '../app/Index/actions';
import { setUserCredentials } from '../app/NotificationsManager/email/Authentication/actions';
import { isSpecificTestAbOption } from '../app/TestAb/selectors';
import { TEST_IDS } from '../app/TestAb/constants';
import { dealTypeIdToString } from '../app/utils/dealType';
import pageWithReduxAndIntl from '../app/hoc/PageWithReduxAndIntl';
import {
  tranformQueryToSearchParametersObject,
  tranformQuerySeoToSearchParametersObject,
} from '../app/utils/searchParameters';
import { dedirify } from '../app/utils/dirify';
import Router from '../app/router';
import {
  getSearchParameterWhatD,
  getWhere,
  routeNameSelector,
  whatOriginalTypedSelector,
} from '~/Serp/selectors';

// this is used for ->
// multiple tag requests in the client so it gets more data (the query will change depending of type of 'home')
// avoid multiple consecutive server requests on initial data load
function runSeoRequestSaga(store, query) {
  const dealTypeString = dealTypeIdToString(query.deal_type);
  const propertyType = query.property_type ? decodeURI(query.property_type) : undefined;
  const dataWhereIn = propertyType ? [propertyType, dealTypeString] : [dealTypeString];
  const data = get(indexSeoSelector(store.getState()), dataWhereIn);

  if (!data || data.length === 0) {
    store.dispatch(fetchIndexSeoRequest(query));
  }
}

class PageSerp extends React.Component {
  static async getInitialProps({ store, res, query }) {
    const state = store.getState();
    const serpState = state.serp;
    const error = get(serpState, 'error');
    const results = get(serpState, 'count');
    const redirectWhat = get(serpState, 'redirectWhat');
    const redirectWhere = get(serpState, 'redirectWhere');
    const isFetching = get(serpState, 'isFetching');
    const currentStateWhat = getSearchParameterWhatD(state);
    const currentStateWhere = getWhere(state);
    const currentStateWhatOriginalTyped = whatOriginalTypedSelector(state);
    const currentRouteName = routeNameSelector(state);
    let statusCode = null;

    const mustRedirect =
      res && // needs to has a result
      ((redirectWhat && redirectWhat !== query.seo) || // needs to has a redirectWhat value and be different of the current query what
        (redirectWhere && redirectWhere !== query.seoWhere)) && // needs to has a redirectWhere value and be different of the current query where
      !query.sem; // It exclude sem (adwords) landings

    if (mustRedirect) {
      const params = { page: query.page };

      if (redirectWhat) {
        params.seo = redirectWhat;
      }

      if (redirectWhere || query.seoWhere) {
        params.seoWhere = redirectWhere || query.seoWhere;
      }

      const urls = Router.findAndGetUrls(query.routeName, params).urls;
      const removeFirstPage = url => url.replace('/1', '');

      res.writeHead(301, { Location: encodeURI(removeFirstPage(urls.as)) });

      return res.end();
    }

    if (error) {
      statusCode = error.status || 500;
    } else if (results === 0 && !isFetching) {
      statusCode = 404;
    }

    if (
      (currentStateWhat === '' && (query.what_d || query.seo)) ||
      (currentRouteName !== query.routeName && query.pageName === 'serp') ||
      (query.seo && dedirify(query.seo).indexOf(currentStateWhatOriginalTyped) === -1) ||
      (query.seoWhere && dedirify(query.seoWhere) !== currentStateWhere)
    ) {
      await this.runInitialSagas({ query, store });
      statusCode = null;
    }

    return { statusCode };
  }

  static async runInitialSagas({ query, store }) {
    const isDisambiguationListTest = isSpecificTestAbOption(
      store.getState(),
      TEST_IDS.disambiguationList,
      'b'
    );
    const searchParams =
      query.seo || query.seoWhere
        ? tranformQuerySeoToSearchParametersObject(query)
        : tranformQueryToSearchParametersObject(query);

    if (isDisambiguationListTest) {
      runSeoRequestSaga(store, query);
    }

    store.dispatch(setSearchParams(searchParams, true));

    // Set alerts manager authentication
    if (query.email && query.userControlToken) {
      store.dispatch(setUserCredentials(query.email, query.userControlToken));
    }
  }

  render() {
    const { query, previousUrl, url } = this.props;

    return (
      <div>
        <Serp query={query} previousUrl={previousUrl} url={url} />
      </div>
    );
  }
}

PageSerp.defaultProps = {
  query: null,
  previousUrl: null,
  url: null,
};

PageSerp.propTypes = {
  query: PropTypes.object,
  previousUrl: PropTypes.string,
  url: PropTypes.string,
};

export default pageWithReduxAndIntl(PageSerp);



// WEBPACK FOOTER //
// ./pages/serp.js